const RULE_TESTS = {
  length: (password) => password.length >= 12,
  uppercase: (password) => /[A-Z]/.test(password),
  lowercase: (password) => /[a-z]/.test(password),
  digit: (password) => /[0-9]/.test(password),
  special: (password) => /[^A-Za-z0-9]/.test(password)
}

const initAdminPasswordRules = () => {
  const rulesList = document.querySelector("[data-admin-password-rules]")
  if (!rulesList) return

  const passwordInput = document.querySelector('[data-admin-password-input="password"]')
  const confirmationInput = document.querySelector('[data-admin-password-input="confirmation"]')
  if (!passwordInput || !confirmationInput) return

  const updateRules = () => {
    const password = passwordInput.value || ""
    const confirmation = confirmationInput.value || ""

    Object.keys(RULE_TESTS).forEach((key) => {
      const item = rulesList.querySelector(`[data-rule="${key}"]`)
      if (!item) return
      item.classList.toggle("is-met", RULE_TESTS[key](password))
    })

    const matchItem = rulesList.querySelector('[data-rule="match"]')
    if (matchItem) {
      matchItem.classList.toggle(
        "is-met",
        password.length > 0 && confirmation.length > 0 && password === confirmation
      )
    }
  }

  passwordInput.addEventListener("input", updateRules)
  confirmationInput.addEventListener("input", updateRules)
  updateRules()
}

export { initAdminPasswordRules }
